import { usePromo } from "../utils/promo";

// Launch campaign banner ("Acceso Fundador"); only shown while the backend's free mode is on
const FounderBanner = ({ ctaLabel = 'Obtener acceso fundador', onCta, secondaryCtaLabel, onSecondaryCta }) => {
  const promo = usePromo();
  if (!promo.free_mode) return null;

  return (
    <div className="bg-emerald-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex-1 min-w-0">
          <span className="inline-block bg-white/20 text-emerald-50 text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-2">
            Oferta de lanzamiento &middot; por tiempo limitado
          </span>
          <h2 className="text-base sm:text-xl font-bold leading-snug">
            Acceso Fundador: eval&uacute;a y consulta inquilinos GRATIS por tiempo limitado
          </h2>
          <p className="text-emerald-50 text-sm sm:text-base mt-1">
            Juntos construimos el historial de inquilinos m&aacute;s confiable del pa&iacute;s. Cada evaluaci&oacute;n protege a otro casero.
          </p>
          <p className="text-emerald-100 text-xs sm:text-sm mt-1">
            Evaluar cuesta <span className="line-through">${promo.rating_price_usd} USD</span> y consultar <span className="line-through">${promo.report_price_usd} USD</span>. Los caseros fundadores no pagan nada durante el lanzamiento.
          </p>
        </div>
        {(onCta || onSecondaryCta) && (
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            {onCta && (
              <button
                onClick={onCta}
                className="bg-white text-emerald-700 font-bold px-6 py-3 rounded-xl hover:bg-emerald-50 transition-colors duration-200"
              >
                {ctaLabel}
              </button>
            )}
            {onSecondaryCta && (
              <button
                onClick={onSecondaryCta}
                className="border-2 border-white text-white font-bold px-6 py-3 rounded-xl hover:bg-white/10 transition-colors duration-200"
              >
                {secondaryCtaLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export { FounderBanner };
